<i18n src="@/i18n/template/components/MyDateRange.json"></i18n>
<template>
  <span class="my-date-range">
    <range-date-picker
      key="start"
      :value="startDate"
      @input="updateStartDate($event)"
      :endTime="endDate"
      :clearable="clearable !== undefined ? clearable : true"
      :placeholder="$t('startTime')"
      :type="datetime ? 'datetime' : 'date'"
      default-time="00:00:00"
      :format="
        datetime
          ? $date.elementTemplate.YearMonthDayHMS
          : $date.elementTemplate.YearMonthDay
      "
      :intervalDays="intervalDays || 0"
      :disabled="disabled"
      :minDate="minDate"
      :maxDate="maxDate"
    >
    </range-date-picker>
    <span style="margin-left: 5px; margin-right: 5px"> - </span>
    <range-date-picker
      key="end"
      :value="endDate"
      @input="updateEndDate($event)"
      :startTime="startDate"
      :clearable="clearable !== undefined ? clearable : true"
      :placeholder="$t('endTime')"
      :type="datetime ? 'datetime' : 'date'"
      :format="
        datetime
          ? $date.elementTemplate.YearMonthDayHMS
          : $date.elementTemplate.YearMonthDay
      "
      default-time="23:59:59"
      :intervalDays="intervalDays || 0"
      :disabled="disabled"
      :minDate="minDate"
      :maxDate="maxDate"
    >
    </range-date-picker>
  </span>
</template>

<script>
export default {
  props: {
    startDate: [String, Date, Number],
    endDate: [String, Date, Number],
    datetime: Boolean,
    placeholder: String,
    disabled: Boolean,
    clearable: Boolean,
    intervalDays: Number, // 相隔天数
    minDate: [String, Date, Number],
    maxDate: [String, Date, Number]
  },
  methods: {
    updateStartDate(value) {
      this.$emit('update:startDate', value) // 发出更新事件
    },
    updateEndDate(value) {
      this.$emit('update:endDate', value) // 发出更新事件
    }
  },
  data() {
    return {}
  }
}
</script>
